// --- smooth scroll --------------

// lenis smooth scroll
const lenis = new Lenis({
  smoothWheel: true, // Smooth wheel behavior
  smoothTouch: false, // Disable smooth touch scrolling (if needed)
  normalizeWheel: true, // Normalize wheel events
  // Ignore elements with the class 'scroll-section' (or any other class you use)
  ignore: (el) => el.classList.contains("scroll-section"),
});

lenis.on("scroll", ScrollTrigger.update);
gsap.ticker.add((time) => {
  lenis.raf(time * 700);
});

gsap.ticker.lagSmoothing(0);

// --- smooth scroll --------------


//{% comment %} =============== Low Power mode code ============ {% endcomment %}

  document.addEventListener('DOMContentLoaded', () => {
    const videos = document.querySelectorAll('video');

    if (!videos.length) return;

    const tryPlay = (video) => {
      if (video.paused) {
        const p = video.play();
        if (p !== undefined) {
          p.catch(() => {});
        }
      }
    };

    // Initial attempt
    videos.forEach((v) => tryPlay(v));

    // iOS-approved user interaction fallback
    const interactionEvents = ['touchstart', 'click', 'pointerdown'];

    const onUserInteraction = () => {
      videos.forEach((v) => tryPlay(v));
      interactionEvents.forEach((evt) => document.removeEventListener(evt, onUserInteraction));
    };

    interactionEvents.forEach((evt) => document.addEventListener(evt, onUserInteraction, { once: true }));

    // Resume if Safari pauses it (common in Low Power Mode)
    videos.forEach((video) => {
      video.addEventListener('pause', () => {
        setTimeout(() => tryPlay(video), 500);
      });
    });
  });

//{% comment %} =============== Low Power mode code ============ {% endcomment %}

// --- Header BG start  --------------

document.addEventListener("DOMContentLoaded", () => {
  const mainHeader = document.querySelector(".main-header");

  document.addEventListener("scroll", () => {
    if (window.scrollY > mainHeader.offsetHeight) {
      mainHeader.classList.add("active");
    } else {
      mainHeader.classList.remove("active");
    }
  });
});

// --- Header BG end --------------




// --------- Draggable Scroll JS ---------
function enableLeftClickDragScroll(container) {
  if (!container) return;

  // console.log("Draggable scroll initialized for element:", container);

  let isDragging = false;
  let dragStarted = false;
  let startX = 0;
  let scrollStart = 0;
  const dragThreshold = 5;
  const scrollSpeedFactor = 0.5; // Lower values = slower scrolling

  container.addEventListener("mousedown", (e) => {
    if (e.button !== 0) return;
    isDragging = true;
    dragStarted = false;
    startX = e.pageX;
    scrollStart = container.scrollLeft;
    container.classList.add("is-dragging");
    e.preventDefault();
  });

  container.addEventListener("mousemove", (e) => {
    if (!isDragging) return;
    const deltaX = e.pageX - startX;

    if (!dragStarted && Math.abs(deltaX) > dragThreshold) {
      dragStarted = true;
    }

    if (dragStarted) {
      container.scrollLeft = scrollStart - deltaX * scrollSpeedFactor;
    }
  });

  container.addEventListener("mouseup", () => {
    isDragging = false;
    container.classList.remove("is-dragging");
  });

  container.addEventListener("mouseleave", () => {
    isDragging = false;
    container.classList.remove("is-dragging");
  });

  container.addEventListener("click", (e) => {
    if (dragStarted) {
      e.preventDefault();
      e.stopPropagation();
      dragStarted = false;
    }
  });

  container.classList.add("is-draggable");
}

function waitForElementAndInit(selector) {
  // Initialize existing elements
  document.querySelectorAll(selector).forEach(el => {
    if (!el._dragInitialized) {
      applyInlineScrollStyles(el);
      enableLeftClickDragScroll(el);
      el._dragInitialized = true;
    }
  });

  // Observe future elements
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof HTMLElement)) return;

        if (node.matches(selector) && !node._dragInitialized) {
          applyInlineScrollStyles(node);
          enableLeftClickDragScroll(node);
          node._dragInitialized = true;
        }

        node.querySelectorAll?.(selector)?.forEach((el) => {
          if (!el._dragInitialized) {
            applyInlineScrollStyles(el);
            enableLeftClickDragScroll(el);
            el._dragInitialized = true;
          }
        });
      });
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
}

function applyInlineScrollStyles(el) {
  el.style.scrollBehavior = "auto";
  el.style.scrollSnapType = "none";
}

document.addEventListener("DOMContentLoaded", () => {
  const scrollSelectors = [".product-grid"];

  scrollSelectors.forEach(selector => {
    waitForElementAndInit(selector);
  });
});

// --------- Draggable JS End---------


// --------------------- New In Grid Collection Select Logic -----------------------

  document.addEventListener('DOMContentLoaded', function () {
    const gridElement = document.querySelector('.collection-product-grid2 .grid');
    const gridOptions = document.querySelectorAll('#grid-options li[data-columns]');
    const eVid1 = document.querySelector('.collection-product-grid2 .product-grid .e-vid-1');
    const grid_1 = document.querySelector('.collection-product-grid2 .grid .grid__item:first-child');
    const grid_6 = document.querySelector('.collection-product-grid2 .grid .grid__item:nth-child(6)');

    gridOptions.forEach(option => {
      option.addEventListener('click', () => {
        const columns = parseInt(option.getAttribute('data-columns'), 10);
        const productItems = gridElement.querySelectorAll('.collection-product-grid2 .grid__item');

        gridElement.style.gridTemplateColumns = `repeat(${columns}, 1fr)`;

        if (eVid1)
          
        
    // Set grid-column-start for .e-vid-1
     {if(columns === 1 ){
       eVid1.style.gridColumnStart='1';
       eVid1.style.gridColumn='auto';
       grid_1.style.gridColumn='auto';
       grid_1.style.padding=0;
       grid_6.style.gridColumn='auto';
       grid_6.style.padding=0;
          if (productItems.length > 6) {
            eVid1.style.display = 'block';
          } else {
            eVid1.style.display = 'none';
          }
       }
        
       else if(columns === 2 ){
         eVid1.style.gridColumnStart='1';
        eVid1.style.gridColumn='span 2/ span 2';
       grid_1.style.gridColumn='span 2/ span 2';
       grid_1.style.padding='2%';
       grid_6.style.gridColumn='span 2/ span 2';
       grid_6.style.padding='2%';
          if (productItems.length > 6) {
            eVid1.style.display = 'block';
          } else {
            eVid1.style.display = 'none';
          }
       }

       else if (columns === 3) {
          eVid1.style.gridColumnStart = '2';
          
           if (productItems.length > 4) {
            eVid1.style.display = 'block';
          } else {
            eVid1.style.display = 'none';
          }
          
        } else if (columns === 4) {
          eVid1.style.gridColumnStart = '3';
          
           if (productItems.length > 6) {
            eVid1.style.display = 'block';
          } else {
            eVid1.style.display = 'none';
          }
          
        } else if (columns === 6) {
           eVid1.style.gridColumnStart = '5';
      
          if (productItems.length > 10) {
            eVid1.style.display = 'block';
          } else {
            eVid1.style.display = 'none';
          }
          
        }}

        // Highlight selected grid option
        gridOptions.forEach(opt => opt.classList.remove('active'));
        option.classList.add('active');
      });
    });
  });




// --------------- animate--slide-in applied only for desktop --------------
document.addEventListener('DOMContentLoaded', function () {
    const gridItems = document.querySelectorAll(' .product-grid-container .collection  .grid__item');
    const mediaQuery = window.matchMedia('(max-width: 950px)'); // Mobile screen width

    function updateScrollTriggerClasses() {
        gridItems.forEach(item => {
            if (mediaQuery.matches) {
                // Remove classes for mobile
                item.classList.remove('scroll-trigger', 'animate--slide-in');
            } else {
                // Add classes for desktop/tablet
                if (settings.animations_reveal_on_scroll) {
                    item.classList.add('scroll-trigger', 'animate--slide-in');
                }
            }
        });
    }

    // Run the function on initial load
    updateScrollTriggerClasses();

    // Update the classes when the window is resized
    mediaQuery.addEventListener('change', updateScrollTriggerClasses);
});
// --------------- animate--slide-in applied only for desktop end --------------



// --------------------- New In Grid Collection Select Logic End -----------------------




// -------- marquee close btn mobile -------

// function closemq() {
//   const marqueecl = document.querySelector(".mob-marquee-span");
//   marqueecl.classList.toggle("close");
// }

// -------- marquee close btn mobile end ----------


// ------------------- Adjust the top of the sticky box -------

function closemq() {
  const marqueecl = document.querySelector(".mob-marquee-span");
  marqueecl.classList.toggle("close");

//Adjust the top of the sticky box
  const isClosed = marqueecl.classList.contains("close");
  
  const stickyBox = document.querySelector(".collection-sticky-box");
  
  if (isClosed) {
    stickyBox.style.top = '11.5vw';
  } else {
    stickyBox.style.top = '18.5vw';
  }
}

// ------------------- Adjust the top of the sticky box end-------


// ------------ mobile menu x design -----

const toggleBtn = document.querySelector('.toggle-btn-d');
const mobMenuBox = document.querySelector('.mob-menu-box');

toggleBtn.addEventListener('click', () => {
  toggleBtn.classList.toggle('active');
  mobMenuBox.classList.toggle('active');
});

// ------------ mobile menu x design -----


// ------- mobile menu inner tabs --------

  document.addEventListener("DOMContentLoaded", function () {
    const menuBox = document.querySelector(".mob-menu-box");

    if (!menuBox) return; // Exit if not present

    const tabs = menuBox.querySelectorAll(".menu-tab-list li");
    const contents = menuBox.querySelectorAll(".menu-tab-content");

    tabs.forEach(tab => {
      tab.addEventListener("click", function () {
        // Handle active class on tabs
        tabs.forEach(t => t.classList.remove("active"));
        this.classList.add("active");

        const target = this.dataset.target;

        // Show matching content block
        contents.forEach(content => {
          content.classList.toggle("show", content.dataset.content === target);
        });
      });
    });
  });


// ------- mobile menu inner tabs --------



// --- STOP SCROLL ON HOVER box---
document.addEventListener("DOMContentLoaded", () => {
  const hoverElement = document.querySelector('.plz-hoverme');

  if (hoverElement) {
    hoverElement.addEventListener('mouseenter', () => {
      document.documentElement.classList.add("lock-hover");
      document.body.classList.add("lock-hover");
      lenis?.stop?.();
    });

    hoverElement.addEventListener('mouseleave', () => {
      document.documentElement.classList.remove("lock-hover");
      document.body.classList.remove("lock-hover");
      if (!isAnyScrollLockActive()) lenis?.start?.();
    });
  }
// --- STOP SCROLL ON HOVER box---


  
// --- STOP SCROLL ON MOBILE MENU BOX OPEN ---  
const mob_menuBox = document.querySelector('.mob-menu-box');
  if (mob_menuBox) {
    new MutationObserver(() => {
      const ismenuActive = mob_menuBox.classList.contains('active');
      document.documentElement.classList.toggle('lock-search', ismenuActive);
      document.body.classList.toggle('lock-search', ismenuActive);
      if (isAnyScrollLockActive()) {
        lenis?.stop?.();
      } else {
        lenis?.start?.();
      }
    }).observe(mob_menuBox, { attributes: true, attributeFilter: ['class'] });
  }
// --- STOP SCROLL ON MOBILE MENU BOX OPEN ---

  

  // --- STOP SCROLL ON SEARCH BOX OPEN ---
  const searchBox = document.querySelector('.my-search-box');
  if (searchBox) {
    new MutationObserver(() => {
      const isActive = searchBox.classList.contains('active');
      document.documentElement.classList.toggle('lock-search', isActive);
      document.body.classList.toggle('lock-search', isActive);
      if (isAnyScrollLockActive()) {
        lenis?.stop?.();
      } else {
        lenis?.start?.();
      }
    }).observe(searchBox, { attributes: true, attributeFilter: ['class'] });
  }

  
  // --- Helper Function ---
  function isAnyScrollLockActive() {
    return (
      document.documentElement.classList.contains('lock-hover') ||
      document.documentElement.classList.contains('lock-search')
    );
  }
});

  // --- STOP SCROLL ON SEARCH BOX OPEN ---


// ------- when shopall hover z-index:0 of sticky-box -------

document.addEventListener("DOMContentLoaded", () => {
  const hoverEl = document.querySelector('.plz-hoverme');
  const stickyBox = document.querySelector('.collection-sticky-box');
  if (!hoverEl || !stickyBox) return;

  hoverEl.addEventListener('mouseenter', () => stickyBox.style.zIndex = '0');
  hoverEl.addEventListener('mouseleave', () => stickyBox.style.zIndex = '');
});

// ------- when shopall hover z-index:0 of sticky-box -------




// --- when open search and mobile menu set z-index:0 to sticky box -----

document.addEventListener("DOMContentLoaded", () => {
  const stickyBox = document.querySelector('.collection-sticky-box');
  const checkZIndex = () => {
    const isSearchActive = document.querySelector('.my-search-box')?.classList.contains('active');
    const isMenuActive = document.querySelector('.mob-menu-box')?.classList.contains('active');
    if(stickyBox) stickyBox.style.zIndex = (isSearchActive || isMenuActive) ? '0' : '';
  };

  ['.my-search-box', '.mob-menu-box'].forEach(selector => {
    const el = document.querySelector(selector);
    if (!el) return;
    new MutationObserver(checkZIndex).observe(el, {
      attributes: true,
      attributeFilter: ['class']
    });
  });
});

// --- when open search and mobile menu set z-index:0 to sticky box -----

// ========== Out of stock ==========

// Function to update stock status immediately
function updateStockStatus(isOutOfStock) {
  const inventoryElement = document.querySelector(
    ".my-inventory.product__inventory"
  );

  if (isOutOfStock) {
    // Update to out of stock
    inventoryElement.innerHTML = `
      <span class="svg-wrapper" style="color: #C80505">
        <!-- Out of stock icon or alternative -->
      </span>
      Out of stock
    `;
  } else {
    // Update to in stock
    inventoryElement.innerHTML = `
      <span class="svg-wrapper" style="color: #C80505">
        <!-- In stock icon or alternative -->
      </span>
      In stock
    `;
  }
}

// Listen for changes to your specific button
document.addEventListener("DOMContentLoaded", function () {
  const targetButton = document.querySelector(
    ".product-form__submit"
  );

  if (targetButton) {
    // Watch for disabled attribute changes on your button
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "disabled"
        ) {
          const isDisabled = targetButton.hasAttribute("disabled");
          updateStockStatus(isDisabled);
        }
      });
    });

    observer.observe(targetButton, {
      attributes: true,
      attributeFilter: ["disabled"],
    });

    // Also check initial state
    const isInitiallyDisabled = targetButton.hasAttribute("disabled");
    updateStockStatus(isInitiallyDisabled);
  }

  // Listen for variant/option changes that might affect stock
  const variantSelectors = document.querySelectorAll(
    'select[name*="id"], input[name*="id"], .product-form__input'
  );
  variantSelectors.forEach((selector) => {
    selector.addEventListener("change", function () {
      // Small delay to let the button state update first
      setTimeout(() => {
        const button = document.querySelector(
          "#ProductSubmitButton-template--17032878817346__main"
        );
        if (button) {
          const isDisabled = button.hasAttribute("disabled");
          updateStockStatus(isDisabled);
        }
      }, 100);
    });
  });
});

// Alternative approach using Shopify's variant change events (if using Shopify)
document.addEventListener("variant:change", function (event) {
  const variant = event.detail.variant;
  const isOutOfStock = !variant || !variant.available;
  updateStockStatus(isOutOfStock);
});

// ========== Out of stock ==========

// document.addEventListener("DOMContentLoaded", function () {

//   (function () {
//     const accordionItemHeaders = document.querySelectorAll(".section>product-info .pdp-accordion .accordion-item-header");
//     accordionItemHeaders.forEach((accordionItemHeader) => {
//       accordionItemHeader.addEventListener("click", function () {
//         const currentlyActive = document.querySelector(".section>product-info .pdp-accordion .accordion-item-header.active");

//         if (currentlyActive && currentlyActive !== this) {
//           currentlyActive.classList.remove("active");
//           currentlyActive.nextElementSibling.style.maxHeight = 0;
//         }

//         this.classList.toggle("active");
//         const accordionItemBody = this.nextElementSibling;
//         accordionItemBody.style.maxHeight = this.classList.contains("active")
//           ? accordionItemBody.scrollHeight + "px"
//           : 0;
//       });
//     });
//   })();
// })





// // ================================================

// document.addEventListener('DOMContentLoaded', () => {
// const targets = document.querySelectorAll('.quick-add-modal');
// targets.forEach(model=>{
//   const observer = new MutationObserver((mutationsList) => {
//     for (const mutation of mutationsList) {
//       if (
//         mutation.type === 'attributes' &&
//         mutation.attributeName === 'open'
//       ) {
//         if (model.hasAttribute('open')) {
//             (function () {
//               const accordionItemHeaders = model.querySelectorAll(".pdp-accordion .accordion-item-header");
//               accordionItemHeaders.forEach((accordionItemHeader) => {
//                 accordionItemHeader.addEventListener("click", function () {
//                   const currentlyActive = model.querySelector(".pdp-accordion .accordion-item-header.active");

//                   if (currentlyActive && currentlyActive !== this) {
//                     currentlyActive.classList.remove("active");
//                     currentlyActive.nextElementSibling.style.maxHeight = 0;
//                   }

//                   this.classList.toggle("active");
//                   const accordionItemBody = this.nextElementSibling;
//                   accordionItemBody.style.maxHeight = this.classList.contains("active")
//                     ? accordionItemBody.scrollHeight + "px"
//                     : 0;
//                 });
//               });
//             })();
//         }
//       }
//     }
//   });

//   observer.observe(model, {
//     attributes: true,
//     attributeFilter: ['open'],
//   });
// });


// });


// ------------------- accordian in pdp , quick add , related product quick add accordian -----------

document.addEventListener("DOMContentLoaded", function () {
  
  // ===============================
  // Accordion Click 
  // ===============================
  
  document.addEventListener("click", function (e) {
    
    const header = e.target.closest(".pdp-accordion .accordion-item-header");
    if (!header) return;
    
    const scope = header.closest(".pdp-accordion");
    
    const currentlyActive = scope.querySelector(".accordion-item-header.active");
    
    if (currentlyActive && currentlyActive !== header) {
      currentlyActive.classList.remove("active");
      currentlyActive.nextElementSibling.style.maxHeight = 0;
    }
    
    header.classList.toggle("active");
    
    const body = header.nextElementSibling;
    body.style.maxHeight = header.classList.contains("active")
    ? body.scrollHeight + "px"
    : 0;
    
  });
  
});

// -------------------

// document.addEventListener("DOMContentLoaded", function () {

//   // ===============================
//   // Common Accordion Function
//   // ===============================
  
//   function initAccordion(scope) {

//     const accordionItemHeaders = scope.querySelectorAll(".pdp-accordion .accordion-item-header");

//     accordionItemHeaders.forEach((accordionItemHeader) => {

//       if (accordionItemHeader.dataset.accordionInit) return;
//       accordionItemHeader.dataset.accordionInit = "true";

//       accordionItemHeader.addEventListener("click", function () {

//         const currentlyActive = scope.querySelector(".pdp-accordion .accordion-item-header.active");

//         if (currentlyActive && currentlyActive !== this) {
//           currentlyActive.classList.remove("active");
//           currentlyActive.nextElementSibling.style.maxHeight = 0;
//         }

//         this.classList.toggle("active");

//         const accordionItemBody = this.nextElementSibling;
//         accordionItemBody.style.maxHeight = this.classList.contains("active")
//           ? accordionItemBody.scrollHeight + "px"
//           : 0;

//       });
//     });
//   }

//   // ===============================
//   // 1 Product Page Accordion
//   // ===============================

//   const productInfo = document.querySelector(".section > product-info");
//   if (productInfo) {
//     initAccordion(productInfo);
//   }

//   // ===============================
//   // 2️ Quick Add Modal Accordion
//   // ===============================

//   const modals = document.querySelectorAll(".quick-add-modal");

//   modals.forEach((modal) => {

//     const observer = new MutationObserver((mutationsList) => {

//       mutationsList.forEach((mutation) => {

//         if (
//           mutation.type === "attributes" &&
//           mutation.attributeName === "open" &&
//           modal.hasAttribute("open")
//         ) {
//           initAccordion(modal);
//         }

//       });

//     });

//     observer.observe(modal, {
//       attributes: true,
//       attributeFilter: ["open"],
//     });

//   });

//   // ========== 3 product recommendations =============

// const bodyObserver = new MutationObserver((mutations) => {

//     mutations.forEach((mutation) => {

//       mutation.addedNodes.forEach((node) => {

//         if (node.nodeType === 1 && node.classList.contains("quick-add-modal")) {

//           initAccordion(node);

//           const openObserver = new MutationObserver((mList) => {
//             mList.forEach((m) => {
//               if (
//                 m.type === "attributes" &&
//                 m.attributeName === "open" &&
//                 node.hasAttribute("open")
//               ) {
//                 initAccordion(node);
//               }
//             });
//           });

//           openObserver.observe(node, {
//             attributes: true,
//             attributeFilter: ["open"]
//           });

//         }

//       });

//     });

//   });

//   bodyObserver.observe(document.body, {
//     childList: true,
//     subtree: true
//   });

// });


// ------------------- accordian in pdp , quick add , related product quick add accordian -----------


// =========== pdp video play after quick add container close ===============

document.addEventListener("click", function() {
    const video = document.querySelector(".pdp-cust-video > video");
    const videoMob = document.querySelector(".mobile-video-section > .vdo-div > video");
    if (video) video.play();
    if (videoMob) videoMob.play();
});

// =========== pdp video play after quick add container close ===============


// =========== collection grid change after filter apply ==========

document.addEventListener("DOMContentLoaded", () => {
  let target = document.querySelector("#FacetFiltersFormMobile")

  if (!target) return;
  let observer = new MutationObserver((entries) => {
    const gridElement = document.querySelector('.collection-product-grid2 .grid');
    const gridOptions = document.querySelectorAll('#grid-options li[data-columns]');
    const eVid1 = document.querySelector('.collection-product-grid2 .product-grid .e-vid-1');
    const grid_1 = document.querySelector('.collection-product-grid2 .grid .grid__item:first-child');
    const grid_6 = document.querySelector('.collection-product-grid2 .grid .grid__item:nth-child(6)');

    gridOptions.forEach(option => {
      option.addEventListener('click', () => {
        const columns = parseInt(option.getAttribute('data-columns'), 10);
        const productItems = gridElement.querySelectorAll('.collection-product-grid2 .grid__item');

        gridElement.style.gridTemplateColumns = `repeat(${columns}, 1fr)`;

  
        // Set grid-column-start for .e-vid-1
        if(columns === 1 ){
          eVid1.style.gridColumnStart='1';
          eVid1.style.gridColumn='auto';
          grid_1.style.gridColumn='auto';
          grid_1.style.padding=0;
          grid_6.style.gridColumn='auto';
          grid_6.style.padding=0;
          if (productItems.length > 6) {
            eVid1.style.display = 'block';
          } else {
            eVid1.style.display = 'none';
          }
        }
          
        else if(columns === 2 ){
          eVid1.style.gridColumnStart='1';
          eVid1.style.gridColumn='span 2/ span 2';
          grid_1.style.gridColumn='span 2/ span 2';
          grid_1.style.padding='2%';
          grid_6.style.gridColumn='span 2/ span 2';
          grid_6.style.padding='2%';
            if (productItems.length > 6) {
              eVid1.style.display = 'block';
            } else {
              eVid1.style.display = 'none';
            }
        }

        else if (columns === 3) {
            eVid1.style.gridColumnStart = '2';
            
            if (productItems.length > 4) {
              eVid1.style.display = 'block';
            } else {
              eVid1.style.display = 'none';
            }
            
          } else if (columns === 4) {
            eVid1.style.gridColumnStart = '3';
            
            if (productItems.length > 6) {
              eVid1.style.display = 'block';
            } else {
              eVid1.style.display = 'none';
            }
            
          } else if (columns === 6) {
            eVid1.style.gridColumnStart = '5';
        
            if (productItems.length > 10) {
              eVid1.style.display = 'block';
            } else {
              eVid1.style.display = 'none';
            }
            
          }

        // Highlight selected grid option
        gridOptions.forEach(opt => opt.classList.remove('active'));
        option.classList.add('active');
      });
    });

  })
  observer.observe(target, {
    childList: true,
    subtree: true
  })
})

// =========== collection grid change after filter apply ==========


// ------------- Header Hover Desktop --------------

function headerTabs(tab ,data){
  const tabContainer = tab.closest(".hover-container-wrapper")
  tabContainer.querySelector(".tab.active").classList.remove("active");
  tabContainer.querySelector(".header-container-links.active").classList.remove("active");
  tab.classList.add("active")
  tabContainer.querySelector(`.header-container-links#${data}`).classList.add("active")
}
// ------------- Header Hover Desktop --------------

// document.addEventListener("DOMContentLoaded", function () {

//   const logo = document.querySelector(".logo-wrapper");

//   if (!logo) return;

//   window.addEventListener("scroll", function () {
//     if (window.scrollY > 50) {
//       logo.classList.add("scrolled");
//     } else {
//       logo.classList.remove("scrolled");
//     }
//   });

// });